// ** Dropdowns Imports
import { HelpCircle } from "react-feather"
import UserDropdown from "./UserDropdown"
import { UncontrolledTooltip } from "reactstrap"
// import Chat from "./chat"

const NavbarUser = () => {
    return (
        <ul className="nav navbar-nav align-items-center">
            <a className="me-1" href={'https://drive.google.com/file/d/1o752Hes4SVySZkGy0P3GYDyFsZtHgXy3/view?usp=sharing'} target="_blank">
                <HelpCircle size={25} id='user-guide'/>
                <UncontrolledTooltip target={'user-guide'} placement='top'>
                    Гарын авлага
                </UncontrolledTooltip>
            </a>
            {/* <Chat /> */}
            <UserDropdown />
        </ul>
    )
}
export default NavbarUser
